export default {
    'logout': "You are logged out",
    'afterregister': "Verification link was sent to your e-mail.Pls complete verification to log in to your account.",
    'auth/user-not-found': 'There are no user with such credentials',
    'auth/email-already-in-use': 'The email address is already in use by another account.' ,
    'login': "You must be logged in to see this page",
    'invalid_credentials': 'Invalid credentials',
    'not_allowed': 'You are not allowed to see this page'
}
